import React from 'react';
// import './Body.scss';
export const Head = ({ children }) => {
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=Head.js.map